export const getImageUrl = (imageSrc: string) => {
  // console.log("getImageUrl", imageSrc);
  return imageSrc.includes('https://')
    ? new URL(imageSrc)
    : new URL(`https:${imageSrc}`);
};
